// extracted by mini-css-extract-plugin
export default {"input":"CheckBox_input__DgCp9","formGroup":"CheckBox_formGroup__kOx+C","radioButton":"CheckBox_radioButton__3JfJH"};